module.exports = __webpack_public_path__ + "img/tmp-patients-status-9.ddedffb5.svg";